import { useContext, useEffect } from "react";
import { AppContext } from "../../contexts/AppContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { RouteContext } from "../../contexts/RoutesContext";
import { Colour } from "../Variables";
import { PersonalDetailsForm } from "../components/Forms/PersonalDetailsForm";
import { useSearchParams } from "react-router-dom";

export function ManagedCandidate() {
    const app = useContext(AppContext);
    const routeContext = useContext(RouteContext);
    const [queryParameters] = useSearchParams();
    let aref = queryParameters.get("aref");
    let lmid = queryParameters.get("lmid");

    useEffect(() => {
        routeContext.setRoutes([{ name: (aref?.length ?? 0) == 0 ? "Create candidate" : "Manage candidate", route: null }])
    }, []);

    return (
        <>
            <InfoBanner
                header={`${(aref?.length ?? 0) == 0 ? "Create candidate" : "Manage candidate"}`}
                narrow={false}
                icon={InfoHeaderIcon.CrateCandidate}
                info={`Please provide accurate personal details for the candidate.`}
                subHeader={`${app?.firmName} Online Application System`}
                theme={Colour.White}>
            </InfoBanner>

            {lmid && <div className="alert alert-info">You are creating a direct sourced candidate.</div>}

            <PersonalDetailsForm/>
        </>
    );
}